// extracted by mini-css-extract-plugin
module.exports = {"button":"button-tertiary_button__EZ3oU","dark":"button-tertiary_dark__EelYi","light":"button-tertiary_light__JVUqK","underline":"button-tertiary_underline__BeDpo"};